export default __webpack_public_path__ + "static/media/Logo Minasa white.667410ab.png";